import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Check',
      title: 'Check input',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Success',
    }
  }
}